/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';

import { IInstrumento } from '../../../services/api/dams/DamServices';
import { ColorsLimite } from '../../../environment';
import { VSelectMonitoringFrequency } from '../../shared';

interface TopograficoProps {
    data: IInstrumento
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    validations: any;
    handleFrenquencyChange: (newFrequency: string) => void;
}

export const Topografico: React.FC<TopograficoProps> = ({ data, handleChange, validations, handleFrenquencyChange }) => {

    return (
        <Box width={'100%'}>
            <Grid container direction={'column'} padding={2} spacing={2}>
                <Grid container item direction={'row'} spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Dados do Instrumento</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Elevação'}
                            type='number'
                            id='elevacao'
                            value={data.elevacao || ''}
                            onChange={handleChange}
                            error={validations.elevacao}
                            required
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Unidade de medida'}
                            id='unidade_medida'
                            value={data.unidade_medida || ''}
                            onChange={handleChange}
                            error={validations.unidade_medida}
                            required
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label={'Frequência de monitoramento'}
                            id='freq_monit'
                            value={data.freq_monit || ''}
                            onChange={handleChange}
                            type='number'
                            error={validations.freq_monit}
                            required
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <VSelectMonitoringFrequency
                            initFrequency={data.freq_monit_medida || ''}
                            onTypeChange={(newFrequency) => handleFrenquencyChange(newFrequency)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Limites</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Normal X'}
                            id='limite_faixa_verde'
                            value={data.limite_faixa_verde || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.verde },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Normal Y'}
                            id='limite_faixa_verde_y'
                            value={data.limite_faixa_verde_y || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.verde },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Normal Z'}
                            id='limite_faixa_verde_z'
                            value={data.limite_faixa_verde_z || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.verde },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Atenção X'}
                            id='limite_faixa_amarela'
                            value={data.limite_faixa_amarela || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.amarelo },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Atenção Y'}
                            id='limite_faixa_amarela_y'
                            value={data.limite_faixa_amarela_y || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.amarelo },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Atenção Z'}
                            id='limite_faixa_amarela_z'
                            value={data.limite_faixa_amarela_z || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.amarelo },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Alerta X'}
                            id='limite_faixa_laranja'
                            value={data.limite_faixa_laranja || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.laranja },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Alerta Y'}
                            id='limite_faixa_laranja_y'
                            value={data.limite_faixa_laranja_y || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.laranja },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Alerta Z *'}
                            id='limite_faixa_laranja_z'
                            value={data.limite_faixa_laranja_z || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.laranja },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Emergência X'}
                            id='limite_faixa_vermelha'
                            value={data.limite_faixa_vermelha || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.vermelho },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Emergência Y'}
                            id='limite_faixa_vermelha_y'
                            value={data.limite_faixa_vermelha_y || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.vermelho },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={'Limite Emergência Z'}
                            id='limite_faixa_vermelha_z'
                            value={data.limite_faixa_vermelha_z || ''}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                                style: {
                                    WebkitTextStroke: '0.1px black',
                                    color: 'inherit',
                                },
                            }}
                            InputProps={{
                                style: { backgroundColor: ColorsLimite.vermelho },
                            }}
                        />
                    </Grid>

                </Grid>
            </Grid>
        </Box>
    );
};